import { useController, ApplicationView } from '@aha-app/mvc';
import React, { useEffect, useRef, useState } from 'react';
import SelectionController from './SelectionController';
import SelectionMenu from './SelectionMenu';

const SelectionContextMenu = () => {
  const menuRef = useRef<HTMLAhaMenuContentElement>();
  const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
  const [menuStyle, setMenuStyle] = useState({
    // Initially render off-screen to avoid the menu briefly
    // appearing out of position to the user
    top: windowHeight + 100,
    left: windowWidth + 100,
  });
  const [renderCount, setRenderCount] = useState(0);
  const controller = useController(SelectionController);
  const { open, x, y } = controller.state.contextMenu;

  useEffect(() => {
    if (!open || !menuRef.current) return;
    const { width: menuWidth, height: menuHeight } =
      menuRef.current.getBoundingClientRect();
    if (renderCount && menuHeight > 20) {
      setMenuStyle({
        top: windowHeight - y < menuHeight ? y - menuHeight : y,
        left: windowWidth - x < menuWidth ? x - menuWidth : x,
      });
    } else {
      // The full menu height can't be determined from the first couple of
      // renders. Re-render until we get a height that includes child items.
      requestAnimationFrame(() => setRenderCount(c => c + 1));
    }
  }, [open, x, y, windowHeight, windowWidth, renderCount]);

  if (!open) return null;

  return (
    <SelectionMenu
      menuRef={menuRef}
      menuStyle={menuStyle}
      open={open}
      id='action-context-menu'
    />
  );
};

export default ApplicationView(SelectionContextMenu);
